module.exports = __webpack_public_path__ + "static/parkway-6f4810a6a84c47c65d05f90cabd5dca0.png";